module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/110-guinea-643f4fc3b62730306823adb8da0eeb5c.svg";